// extracted by mini-css-extract-plugin
export default {"register":"register_register__w84Dd","link":"register_link__ciHIo","or":"register_or__t5KWG"};